// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__3425T","row":"ProcedureTreatmentSummary_row__2tMld"};